import { apiHelper } from "../utils/helpers";
import endpoints from "@/utils/constants";

export default {
  data() {
    return { branchDetails: null };
  },
  computed: {
    branchDisplayName() {
      if (!this.branchDetails) return "Rajput Electricals";
      return this.branchDetails.legal_name || this.branchDetails.name || "Rajput Electricals";
    },
    branchAddress() {
      return (this.branchDetails && this.branchDetails.address) || "";
    },
    branchAddressLines() {
      const addr = this.branchAddress;
      if (!addr) return ["", ""];
      const mid = Math.floor(addr.length / 2);
      let bestIdx = -1;
      let bestDist = Infinity;
      for (let i = 0; i < addr.length; i++) {
        if (addr[i] === ",") {
          const dist = Math.abs(i - mid);
          if (dist < bestDist) {
            bestDist = dist;
            bestIdx = i;
          }
        }
      }
      if (bestIdx === -1) return [addr, ""];
      return [addr.slice(0, bestIdx).trim(), addr.slice(bestIdx + 1).trim()];
    },
    branchPhone() {
      return (this.branchDetails && this.branchDetails.phone) || "";
    },
    branchGstin() {
      if (!this.branchDetails || !this.branchDetails.is_gst) return "";
      return this.branchDetails.gst_number || "";
    },
    branchBankName() {
      return (this.branchDetails && this.branchDetails.bank_name) || "";
    },
    branchAccountHolder() {
      return (this.branchDetails && this.branchDetails.account_holder_name) || "";
    },
    branchAccountNumber() {
      return (this.branchDetails && this.branchDetails.account_number) || "";
    },
    branchIfscCode() {
      return (this.branchDetails && this.branchDetails.ifsc_code) || "";
    },
    branchBankBranch() {
      return (this.branchDetails && this.branchDetails.bank_branch) || "";
    },
    branchUpiId() {
      return (this.branchDetails && this.branchDetails.upi_id) || "";
    }
  },
  methods: {
    async loadBranchDetails(nameOrId) {
      try {
        const res = await apiHelper.call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/branches`
        );
        const branches = (res.data && res.data.data) || [];
        if (!nameOrId) {
          this.branchDetails =
            branches.find(b => b.is_default) || branches[0] || null;
          return;
        }
        const key = nameOrId.toString().toLowerCase().trim();
        this.branchDetails =
          branches.find(b => b.id === nameOrId) ||
          branches.find(b => b.name && b.name.toLowerCase().trim() === key) ||
          branches.find(b => b.legal_name && b.legal_name.toLowerCase().trim() === key) ||
          null;
      } catch {
        this.branchDetails = null;
      }
    }
  }
};
